import { useQuery } from "convex/react";
import { useState } from "react";
import { api } from "../../convex/_generated/api";
import { authClient, getActiveOrgId } from "./authClient";
import { identifyUser, resetUser } from "./posthog";

/**
 * Identifies PostHog user on session hydration, resets on sign-out.
 * No useEffect — uses the set-state-during-render dedup pattern (matches addin telemetry).
 */
export function usePostHogIdentify(): null {
	const session = authClient.useSession();
	const viewer = useQuery(api.lib.viewer.getCurrentSession, {});
	const [identifiedKey, setIdentifiedKey] = useState<string | null>(null);

	const currentUserId = viewer?.userId
		? String(viewer.userId)
		: (session.data?.user?.id ?? null);
	const tenantId = viewer?.tenantId ? String(viewer.tenantId) : null;
	const currentKey = currentUserId
		? `${currentUserId}:${tenantId ?? "loading"}`
		: null;

	if (currentUserId && currentKey !== identifiedKey) {
		setIdentifiedKey(currentKey);
		identifyUser({
			userId: currentUserId,
			email: viewer?.userEmail ?? session.data?.user?.email ?? null,
			name: viewer?.userName ?? session.data?.user?.name ?? null,
			activeOrganizationId: session.data
				? getActiveOrgId(session.data.session)
				: null,
			tenantId,
		});
	} else if (!currentUserId && identifiedKey) {
		setIdentifiedKey(null);
		resetUser();
	}

	return null;
}
